import { stateful, useState } from '@adornis/functional-lit/stateful.js';
import { html } from 'lit';

export interface EditorLoginProps {
  title?: string;
  email: string;
  password: string;
  message: string;
  isLoading: boolean;
  handleLogin: (event: SubmitEvent) => Promise<void>;
  setEmail: (email: string) => void;
  setPassword: (password: string) => void;
}

export const editorLogin = stateful((props: EditorLoginProps) => {
  const [showPassword, setShowPassword] = useState(false, []);

  return html`
    <main class="vp-editor-login-page">
      <form class="vp-editor-login-card" @submit=${props.handleLogin}>
        <div>
          <p class="vp-editor-kicker">${props.title ?? 'Web Editor'}</p>
          <h1>Landingpage bearbeiten</h1>
        </div>
        <div class="vp-editor-login-field">
          <label for="vp-editor-email">E-Mail</label>
          <input
            id="vp-editor-email"
            type="email"
            name="email"
            inputmode="email"
            autocomplete="username"
            autocapitalize="none"
            autocorrect="off"
            enterkeyhint="next"
            placeholder="name@unternehmen.de"
            spellcheck="false"
            required
            .value=${props.email}
            @input=${(event: InputEvent) => props.setEmail((event.target as HTMLInputElement).value)}
          />
        </div>
        <div class="vp-editor-login-field">
          <label for="vp-editor-password">Passwort</label>
          <span class="vp-editor-password-field">
            <input
              id="vp-editor-password"
              type=${showPassword ? 'text' : 'password'}
              name="password"
              autocomplete="current-password"
              enterkeyhint="go"
              placeholder="Passwort eingeben"
              required
              .value=${props.password}
              @input=${(event: InputEvent) => props.setPassword((event.target as HTMLInputElement).value)}
            />
            <button
              type="button"
              class="vp-editor-password-toggle"
              aria-controls="vp-editor-password"
              aria-pressed=${String(showPassword)}
              aria-label=${showPassword ? 'Passwort ausblenden' : 'Passwort anzeigen'}
              title=${showPassword ? 'Passwort ausblenden' : 'Passwort anzeigen'}
              @click=${() => setShowPassword(!showPassword)}
            >
              <span
                class=${showPassword
                  ? 'icon-[material-symbols--visibility-off-outline]'
                  : 'icon-[material-symbols--visibility-outline]'}
                aria-hidden="true"
              ></span>
            </button>
          </span>
        </div>
        <button type="submit" class="vp-editor-login-submit" ?disabled=${props.isLoading}>
          ${props.isLoading ? 'Anmeldung läuft …' : 'Login'}
        </button>
        ${props.message ? html`<p class="vp-editor-message" role="alert">${props.message}</p>` : ''}
        <a href="/" class="vp-editor-login-back">
          <span class="icon-[material-symbols--arrow-back-rounded]" aria-hidden="true"></span>
          <span>Zur Landingpage</span>
        </a>
      </form>
    </main>
  `;
});
